import request from '@/utils/request'
import qs from 'qs'

export function getRoomAvaiSubGroupApi(query) {
  return request({
    url: '/booking-service/v1/booking-group/available-room-level-list',
    method: 'get',
    params: query
  })
}

export function getPriceCodeApi(query) {
  return request({
    url: '/booking-service/v1/booking/get-price-code',
    method: 'get',
    params: query
  })
}

export function addGroupApi(data) {
  return request({
    url: '/booking-service/v1/booking-group/insert',
    method: 'post',
    data: data
  })
}

export function getGroupByIdApi(id) {
  return request({
    url: '/booking-service/v1/booking-group/' + id,
    method: 'get'
  })
}

export function updateGroupApi(id, data) {
  return request({
    url: '/booking-service/v1/booking-group/update/' + id,
    method: 'put',
    data: data
  })
}

export function getMenuChildApi(query) {
  return request({
    url: '/auth-service/v1/menu-child',
    method: 'get',
    params: query
  })
}

export function getSubGroupByGroupIdApi(data) {
  return request({
    url: '/booking-service/v1/sub-booking-group/list-by-booking-group',
    method: 'get',
    params: data
  })
}

export function getSubGroupByIdApi(id, query) {
  return request({
    url: '/booking-service/v1/sub-booking-group/' + id,
    method: 'get',
    params: query
  })
}

export function getGuestListApi(id, query) {
  return request({
    url: '/booking-service/v1/sub-booking-group/' + id + '/traveller-list',
    method: 'get',
    params: query
  })
}

export function getRoomListApi(query) {
  return request({
    url: '/config-service/v1/hotel/room/available',
    method: 'get',
    params: query
  })
}

export function getHotelListApi(query) {
  return request({
    url: '/config-service/v1/hotel/hotel/all',
    method: 'get',
    params: query
  })
}

export function getConfirmCodeApi(query) {
  return request({
    url: '/booking-service/v1/booking/get-confirm-code',
    method: 'get',
    params: query
  })
}

export function getListAgentToExcelApi(query) {
  return request({
    url: '/booking-service/v1/booking-group/to-excel',
    method: 'get',
    params: query,
    responseType: 'blob'
  })
}

export function getDepartmentApi(query) {
  return request({
    url: '/config-service/v1/department/list-non--paging',
    method: 'get',
    params: query
  })
}
export function addMissionApi(data) {
  return request({
    url: '/booking-service/v1/missions/insert',
    method: 'post',
    data
  })
}

export function updateMissionApi(id, data) {
  return request({
    url: '/booking-service/v1/missions/' + id,
    method: 'put',
    data
  })
}

export function successfulMissionApi(id, data = {}) {
  return request({
    url: '/booking-service/v1/missions/' + id + '/complete',
    method: 'patch',
    data
  })
}

export function cancelSuccessfulMissionApi(id, data = {}) {
  return request({
    url: '/booking-service/v1/missions/' + id + '/complete-cancel',
    method: 'patch',
    data
  })
}

export function cancelMissionApi(id, data = {}) {
  return request({
    url: '/booking-service/v1/missions/' + id + '/cancel',
    method: 'patch',
    data
  })
}

export function getRoomListByGroupIdApi(data) {
  return request({
    url: '/booking-service/v1/booking-group/rooms',
    method: 'get',
    params: data
  })
}
export function cancelRoomApi(data) {
  return request({
    url: '/booking-service/v1/booking/cancel',
    method: 'patch',
    data
  })
}
export function cancelCheckinApi(data) {
  return request({
    url: '/booking-service/v1/booking/cancel-check-in',
    method: 'patch',
    params: data
  })
}
export function setMasterRoomApi(data) {
  return request({
    url: '/booking-service/v1/booking/master-setting',
    method: 'patch',
    params: data
  })
}
export function checkinApi(data) {
  return request({
    url: '/booking-service/v1/booking/check-in',
    method: 'post',
    data
  })
}

export function getRoomRowApi(data) {
  return request({
    url: '/booking-service/v1/booking-group/available-room-level-list',
    method: 'get',
    params: data
  })
}

export function getListSubTransactionApi(data = {}) {
  return request({
    url: '/config-service/v1/transaction/sub-transaction/list-simple',
    method: 'get',
    params: data
  })
}

export function getReceiveBankAccountApi(data = {}) {
  return request({
    url: '/config-service/v1/bank-account/list',
    method: 'get',
    params: data
  })
}

export function codeBaseApi(data = {}) {
  return request({
    url: '/config-service/v1/statistic/code/code-base',
    method: 'get',
    params: data
  })
}

export function addDepositApi(data = {}) {
  return request({
    url: '/booking-service/v1/deposit',
    method: 'post',
    data
  })
}

export function getGroupBalanceApi(data = {}) {
  return request({
    url: '/booking-service/v1/booking-group-remainder/' + data,
    method: 'get',
    data
  })
}
export function getRoomBalanceApi(data) {
  return request({
    url: '/booking-service/v1/booking-balance/' + data,
    method: 'get'
  })
}
export function getRoomBalanceCancelApi(data) {
  return request({
    url: '/booking-service/v1/booking-balance',
    params: data,
    method: 'get',
    paramsSerializer: query => {
      return qs.stringify(query, { arrayFormat: 'repeat' })
    }
  })
}

export function cancelBookingApi(data = {}) {
  return request({
    url: '/booking-service/v1/booking-group/cancel',
    method: 'patch',
    data
  })
}

export function getDailyPriceApi(data = {}) {
  return request({
    url: '/booking-service/v1/booking/generate-daily-price',
    method: 'get',
    params: data
  })
}

export function createSubGroupApi(data) {
  return request({
    url: '/booking-service/v1/sub-booking-group/insert',
    method: 'post',
    data
  })
}
export function updateSubGroupApi(id, params, data) {
  return request({
    url: '/booking-service/v1/sub-booking-group/update/' + id,
    method: 'put',
    data,
    params: params
  })
}

export function assignAutoRoomApi(data) {
  return request({
    url: '/booking-service/v1/sub-booking-group/assign-room',
    method: 'get',
    params: data
  })
}

export function updateRoomGuestApi(query, data) {
  return request({
    url: '/booking-service/v1/sub-booking-group/update-traveller-list',
    method: 'post',
    params: query,
    data
  })
}

export function deleteSubGroupApi(query, data) {
  return request({
    url: '/booking-service/v1/sub-booking-group/' + query,
    method: 'delete',
    params: data
  })
}

export function getTransGeneralInfo(params) {
  return request({
    url: `/booking-service/v1/booking-group/list-transaction/${params.id}`,
    method: 'get'
  })
}

export function getTransactionByPage(params) {
  return request({
    url: `/booking-service/v1/booking-group/list-transaction-by-page/${params.id}`,
    method: 'get',
    params: params
  })
}

export function getMissions(query) {
  return request({
    url: '/booking-service/v1/missions/list-all',
    method: 'get',
    params: query
  })
}

export function getBooking(id) {
  return request({
    url: `/booking-service/v1/booking/${id}`,
    method: 'get'
  })
}

export function getBookingTravellers(id) {
  return request({
    url: `/booking-service/v1/booking/${id}/travellers`,
    method: 'get'
  })
}
export function getBookingDetailPrice(id) {
  return request({
    url: `/booking-service/v1/booking/${id}/detail-price`,
    method: 'get'
  })
}

export function updateBooking(id, payload) {
  return request({
    url: `/booking-service/v1/booking/update/${id}`,
    method: 'put',
    data: payload
  })
}

export function getRoomBookingListApi(id, params) {
  return request({
    url: `/booking-service/v1/sub-booking-group/${id}/room-booking`,
    method: 'get',
    params: params
  })
}

export function updateRoomBookingApi(payload) {
  return request({
    url: `/booking-service/v1/sub-booking-group/update-room-booking`,
    method: 'put',
    data: payload
  })
}
export function getRegisterFormApi(query) {
  return request({
    url: `/booking-service/v1/booking/register-info`,
    method: 'get',
    params: query
  })
}

export function getConfirmBooking(query) {
  return request({
    url: `/booking-service/v1/booking/confirm-booking`,
    method: 'get',
    params: query
  })
}
export function getConfirmBookingWithDiscount(query) {
  return request({
    url: `/booking-service/v1/booking/confirm-booking-with-discount`,
    method: 'get',
    params: query
  })
}
export function getComboListApi(query) {
  return request({
    url: `/booking-service/v1/booking/list-package`,
    method: 'get',
    params: query
  })
}
